import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';
import { LEFT, RIGHT, TOP, BOTTOM, CENTER } from './config';
import styles from './styles/styles.css';

export const BlockHolder: FC<IProps> = props => {
    const {
        alignX = CENTER,
        alignY = CENTER,
        className,
        height,
        width,
        minWidth,
        minHeight,
        ...rest
    } = props;

    const classNames = cn(
        styles.block,
        {
            [styles.alignXLeft]: alignX === LEFT,
            [styles.alignXCenter]: alignX === CENTER,
            [styles.alignXRight]: alignX === RIGHT,
            [styles.alignYTop]: alignY === TOP,
            [styles.alignYCenter]: alignY === CENTER,
            [styles.alignYBottom]: alignY === BOTTOM,
        },
        className
    );

    return <div className={classNames} style={{ width, height, minWidth, minHeight }} {...rest} />;
};
